import { render, staticRenderFns } from "./GeneralSettings.vue?vue&type=template&id=fdc3caa0&scoped=true&"
import script from "./GeneralSettings.vue?vue&type=script&lang=js&"
export * from "./GeneralSettings.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSettings.vue?vue&type=style&index=0&id=fdc3caa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc3caa0",
  null
  
)

export default component.exports